<template>
  <svg
    id="Smartphone--Streamline-Nova"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <desc>Smartphone Streamline Icon: https://streamlinehq.com</desc>
    <path
      d="M18 4a2 2 0 0 0 -2 -2H8a2 2 0 0 0 -2 2v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2zm-2 14H8V6h8z"
      fill="currentColor"
      stroke-width="1"
    />
  </svg>
</template>
